import type { CashbackOfferAdminDto } from '@/backend/market'
import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CashbackOfferEntity } from '../../domain/entities/CashbackOfferEntity'

export class CashbackModel extends CashbackOfferEntity {
  constructor(dataDto: CashbackOfferAdminDto) {
    super()
    mapEntityProperties<CashbackOfferEntity>(this, dataDto)
  }
}
